import { columns, drawerFilters } from "./helpers"
import { useState } from 'react'
import { toTableRowItems } from './serializers'
import { useNavigate } from 'react-router-dom'
import { URLS } from '../../constants'
import s from '../../../commonStyles.modules.scss'
import { makeCoreGetFileRequest, makeCoreGetRequest } from "utils/api"
import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { DownloadIcon, ViewActionIcon } from "icons"
import { Order } from './interfaces'
import { getDsStatusOptions, getShopOptions } from "../../api"
import { formatAndDownloadResponse } from "../../../../../utils/helpers"

const Orders = ({ isHistorical }) => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()
  const [tableItems, setTableItems] = useState<Order[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: isHistorical
            ? '/shop-reception/ds-orders-archive'
            : '/shop-reception/ds-orders',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list || []))
      setTotalCount(response.page?.totalCount || 0)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const handleDownload = async (rowId: string | number) => {
    try {
      const endpoint = isHistorical
        ? `/shop-reception/ds-orders-archive/report-print/${rowId}`
        : `/shop-reception/ds-orders/report-print/${rowId}`

      const pdfBlob = await makeCoreGetFileRequest(endpoint, { responseType: 'blob' })
      formatAndDownloadResponse(pdfBlob)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la descarcare. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const { data: shopCodes } = getShopOptions(showNotification)
  const { data: statusOptions } = getDsStatusOptions(showNotification)

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActions={[
          {
            label: 'Show',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#16a085',
            desktopIcon: <ViewActionIcon />,
            onClick: (_e, rowId) => {
              const row = tableItems.find(r => String(r.id) === String(rowId))

              const target = isHistorical
                ? URLS.AUTH_SUPPLIERS_ORDER_HISTORICAL.replace(':id', rowId)
                : URLS.AUTH_SUPPLIERS_ORDER.replace(':id', rowId)

              navigate(target, { state: { fromOrdersRow: row } })
            }
          },
          {
            label: '',
            labelColor: 'white',
            typographyVariant: 'medium',
            backgroundColor: '#2980b9',
            desktopIcon: <DownloadIcon />,
            hideCondition: {
              field: 'productsProcessedTime',
              value: null
            },
            onClick: async (_e, rowId) => {
              await handleDownload(rowId)
            }
          }
        ]}
        rowActionsWidth="130px"
        filters={drawerFilters(shopCodes, statusOptions)}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default Orders
